// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-fullscreen-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  padding: 20px;
  background-color: black;
  position: relative; /* Position relative to contain shooting star */
  overflow: hidden; /* Hide overflow to keep animation within bounds */
}

.menu-content {
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.menu-heading1 {
  font-size: 3em;
  margin-bottom: 20px;
  color: white;
  text-shadow: 0 0 5px rgb(255, 255, 255);
}

.menu-category-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 60px;
  max-height: 62vh; /* Begrenzung der Höhe auf 60% der Viewport-Höhe */
  overflow-y: auto; /* Ermöglicht vertikales Scrollen */
  padding-right: 10px; /* Platz für Scrollbar */
}

.menu-category-button {
  width: 100%;
  max-width: 300px;
  padding: 12px 0;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, border 0.3s ease;
}

.menu-category-button:hover {
  background-color: #a1a1a1;
  color: #1a1a1a;
}

/* Special Category Styles */
.special-category {
  border: 3px solid white;
  position: relative;
  animation: specialGlow 2s infinite;
}

@keyframes specialGlow {
  0% {
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
  50% {
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 1);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
}

.stars {
  background: #000 url("https://www.transparenttextures.com/patterns/stardust.png")
    repeat top center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-size: cover;
  animation: starAnimation 300s linear infinite;
}

@keyframes starAnimation {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -10000px 5000px;
  }
}

/* Shooting star effect that flies across the screen */
.shooting-star-reverse {
  position: absolute;
  top: 10%; /* Starting point within visible bounds */
  right: 10%; /* Start from the right side */
  width: 3px;
  height: 100px;
  background: linear-gradient(150deg, white, rgba(255, 255, 255, 0));
  opacity: 0;
  z-index: 1;
  transform: rotate(230deg);
  animation: shootingStarFlyThrough 10s linear infinite;
}

@keyframes shootingStarFlyThrough {
  0% {
    opacity: 0;
    transform: translate(100px, 100px) rotate(230deg);
  }
  5% {
    opacity: 1;
  }
  25% {
    opacity: 1;
    transform: translate(-800px, 800px) rotate(230deg);
  }
  30% {
    opacity: 0;
    transform: translate(-1000px, 1000px) rotate(230deg);
  }
  100% {
    opacity: 0;
    transform: translate(-1000px, 1000px) rotate(230deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/Karte1.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,yBAAyB;EACxC,aAAa;EACb,uBAAuB;EACvB,kBAAkB,EAAE,+CAA+C;EACnE,gBAAgB,EAAE,kDAAkD;AACtE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB,EAAE,kDAAkD;EACpE,gBAAgB,EAAE,mCAAmC;EACrD,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,4CAA4C;IAC5C,sCAAsC;EACxC;EACA;IACE,6CAA6C;IAC7C,oCAAoC;EACtC;EACA;IACE,4CAA4C;IAC5C,sCAAsC;EACxC;AACF;;AAEA;EACE;qBACmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,QAAQ,EAAE,yCAAyC;EACnD,UAAU,EAAE,8BAA8B;EAC1C,UAAU;EACV,aAAa;EACb,kEAAkE;EAClE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,iDAAiD;EACnD;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,oDAAoD;EACtD;EACA;IACE,UAAU;IACV,oDAAoD;EACtD;AACF","sourcesContent":[".menu-fullscreen-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full viewport height */\n  padding: 20px;\n  background-color: black;\n  position: relative; /* Position relative to contain shooting star */\n  overflow: hidden; /* Hide overflow to keep animation within bounds */\n}\n\n.menu-content {\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n.menu-heading1 {\n  font-size: 3em;\n  margin-bottom: 20px;\n  color: white;\n  text-shadow: 0 0 5px rgb(255, 255, 255);\n}\n\n.menu-category-list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 60px;\n  max-height: 62vh; /* Begrenzung der Höhe auf 60% der Viewport-Höhe */\n  overflow-y: auto; /* Ermöglicht vertikales Scrollen */\n  padding-right: 10px; /* Platz für Scrollbar */\n}\n\n.menu-category-button {\n  width: 100%;\n  max-width: 300px;\n  padding: 12px 0;\n  text-align: center;\n  font-size: 1em;\n  font-weight: bold;\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, border 0.3s ease;\n}\n\n.menu-category-button:hover {\n  background-color: #a1a1a1;\n  color: #1a1a1a;\n}\n\n/* Special Category Styles */\n.special-category {\n  border: 3px solid white;\n  position: relative;\n  animation: specialGlow 2s infinite;\n}\n\n@keyframes specialGlow {\n  0% {\n    box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);\n    border-color: rgba(255, 255, 255, 1);\n  }\n  100% {\n    box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n}\n\n.stars {\n  background: #000 url(\"https://www.transparenttextures.com/patterns/stardust.png\")\n    repeat top center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  background-size: cover;\n  animation: starAnimation 300s linear infinite;\n}\n\n@keyframes starAnimation {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: -10000px 5000px;\n  }\n}\n\n/* Shooting star effect that flies across the screen */\n.shooting-star-reverse {\n  position: absolute;\n  top: 10%; /* Starting point within visible bounds */\n  right: 10%; /* Start from the right side */\n  width: 3px;\n  height: 100px;\n  background: linear-gradient(150deg, white, rgba(255, 255, 255, 0));\n  opacity: 0;\n  z-index: 1;\n  transform: rotate(230deg);\n  animation: shootingStarFlyThrough 10s linear infinite;\n}\n\n@keyframes shootingStarFlyThrough {\n  0% {\n    opacity: 0;\n    transform: translate(100px, 100px) rotate(230deg);\n  }\n  5% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 1;\n    transform: translate(-800px, 800px) rotate(230deg);\n  }\n  30% {\n    opacity: 0;\n    transform: translate(-1000px, 1000px) rotate(230deg);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-1000px, 1000px) rotate(230deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
